import { Content } from '../../../Models/Content';

export enum ContentsActionType {
  REQUEST_VIEW_CONTENTS = 'REQUEST_VIEW_CONTENTS',
  RECEIVE_VIEW_CONTENTS = 'RECEIVE_VIEW_CONTENTS',
}

export type ContentsAction = IRequestViewContentsAction | IReceiveViewContentsAction;

export interface IRequestViewContentsAction {
  type: ContentsActionType.REQUEST_VIEW_CONTENTS;
  applicationId: string;
  viewId: string;
}

export interface IReceiveViewContentsAction {
  type: ContentsActionType.RECEIVE_VIEW_CONTENTS;
  viewId: string;
  contents: Content[];
}
